<template>
  <v-row class="ma-0 pa-0 audience-size-wsi-scatter" justify="start">
    <v-col cols="12" class="ma-0 pa-0">
      <v-chart
        class="chart"
        :option="graph_options"
        autoresize
        @click="select_slider"
      ></v-chart>
    </v-col>
  </v-row>
</template>

<script>
import VChart, { THEME_KEY } from "vue-echarts";
import "echarts";
import { use } from "echarts/core";
import { ScatterChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components";

use([
  ScatterChart,
  CanvasRenderer,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
]);

export default {
  name: "AudienceSizeWsiScatter",
  props: ["audience_highlights", "slider_id"],
  provide: {
    [THEME_KEY]: "light",
  },
  components: {
    VChart,
  },
  methods: {
    select_slider: function (params) {
      if (!params || !params.data || params.data.sliderId === undefined) {
        return;
      }

      const sliderId = Number(params.data.sliderId);
      this.$emit(
        "sliderOnChange",
        Number.isNaN(sliderId) ? params.data.sliderId : sliderId
      );
    },
  },
  computed: {
    highlightPoints: function () {
      return Object.keys(this.audience_highlights || {})
        .map((sliderId) => {
          const highlight = this.audience_highlights[sliderId] || {};
          const size = Number(highlight.population);
          const wsi = Number(
            highlight.wsi === undefined || highlight.wsi === null
              ? highlight.wom
              : highlight.wsi
          );

          if (!Number.isFinite(size) || !Number.isFinite(wsi)) {
            return null;
          }

          return {
            name: `Slider ${sliderId}`,
            value: [size, wsi],
            sliderId: sliderId.toString(),
          };
        })
        .filter(Boolean);
    },
    currentPoint: function () {
      const currentSliderId = (this.slider_id === undefined || this.slider_id === null
        ? "0"
        : this.slider_id
      ).toString();

      return this.highlightPoints.find((point) => point.sliderId === currentSliderId);
    },
    graph_options: function () {
      const currentSliderId = this.currentPoint ? this.currentPoint.sliderId : null;
      const allPoints = this.highlightPoints.filter(
        (point) => point.sliderId !== currentSliderId
      );
      const currentPoints = this.currentPoint ? [this.currentPoint] : [];

      return {
        title: {
          text: "Audience Size vs WSI",
          left: "center",
          top: 0,
          textStyle: {
            fontFamily: "Poppins",
            fontSize: 16,
            fontWeight: 600,
          },
        },
        color: ["#6E7781", "#D71920"],
        tooltip: {
          trigger: "item",
          textStyle: {
            fontFamily: "Poppins",
          },
          formatter: function (param) {
            const value = param.value || [];
            return [
              param.name,
              `Size: ${Number(value[0] || 0).toLocaleString()}`,
              `WSI: ${Number(value[1] || 0).toFixed(2)}`,
            ].join("<br/>");
          },
        },
        legend: {
          top: 30,
          left: "center",
          textStyle: {
            fontFamily: "Poppins",
          },
        },
        grid: {
          left: 72,
          right: 32,
          top: 76,
          bottom: 56,
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: "Size",
          nameLocation: "middle",
          nameGap: 34,
          axisLabel: {
            fontFamily: "Poppins",
            fontSize: 11,
            formatter: function (value) {
              return Intl.NumberFormat("en", {
                notation: "compact",
                maximumFractionDigits: 1,
              }).format(value);
            },
          },
          splitLine: {
            show: true,
          },
        },
        yAxis: {
          type: "value",
          name: "WSI",
          nameLocation: "middle",
          nameGap: 48,
          axisLabel: {
            fontFamily: "Poppins",
            fontSize: 11,
          },
          splitLine: {
            show: true,
          },
        },
        series: [
          {
            name: "Highlights",
            type: "scatter",
            data: allPoints,
            symbolSize: 12,
            cursor: "pointer",
          },
          {
            name: "Current Slider",
            type: "scatter",
            data: currentPoints,
            symbolSize: 18,
            cursor: "pointer",
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.audience-size-wsi-scatter {
  height: 100%;
  /* min-height: 360px; */
  width: 100%;
}

.chart {
  height: 100%;
  width: 100%;
}
</style>
